import { render, staticRenderFns } from "./TechSupport.vue?vue&type=template&id=8e06935c&scoped=true&"
import script from "./TechSupport.vue?vue&type=script&lang=js&"
export * from "./TechSupport.vue?vue&type=script&lang=js&"
import style0 from "./TechSupport.vue?vue&type=style&index=0&id=8e06935c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e06935c",
  null
  
)

export default component.exports